var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"x-sortable",on:{"click":_vm.toggle}},[_vm._t("default"),_c('i',{staticClass:"el-icon-caret-top",class:_vm.ascClass}),_c('i',{staticClass:"el-icon-caret-bottom",class:_vm.descClass})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }